import React, { useState, useEffect } from "react";
import {
  ActiveContainer,
  ActiveHeader,
  ActiveHeaderText,
  PassiveContainer,
} from "./styles";

import Iterable from "../Iterable";
import Button from "../../../components/general/Button";
import ArrowDownTask from "../../../assets/TaskModalIcons/ArrowBottomTask";
import ArrowRightTask from "../../../assets/TaskModalIcons/ArrowBottomTask";
import { Fragment } from "react";
import { useHistory } from "react-router-dom";

const updateCheck = (list, item) => {
  return list.map((l) =>
    l.title === item.title ? (l = { ...l, open: !l.open }) : l,
  );
};

const byProjectFormat = (pagination) => {
  let ProjectBy = {};

  pagination.forEach((item) => {
    const index = item.projectName;
    const task = item;

    if (index in ProjectBy) {
      const valueExists = ProjectBy[index].some(
        (obj) => obj.flowId === item.flowId,
      );

      if (valueExists) {
        ProjectBy[index] = [...ProjectBy[index], task];
      }
    } else {
      ProjectBy[index] = [task];
    }
  });

  return ProjectBy;
};

const ProjectIteraction = ({ setTask, pagination = [], pages }) => {
  const projects = byProjectFormat(pagination);

  const activeList = Object.keys(projects).map(
    (item) => (item = { title: item, open: true }),
  );

  const [active, setActive] = useState(activeList);

  const history = useHistory();

  return Object.keys(projects).length > 0 ? (
    <>
      {active.map((item, index) => (
        <Fragment key={index}>
          {item.open ? (
            <ActiveContainer>
              <ActiveHeader>
                <ActiveHeaderText
                  onClick={() => setActive((list) => updateCheck(list, item))}
                >
                  <ArrowDownTask />
                  {item.title}
                </ActiveHeaderText>
                <Button
                  greenBase
                  content="Ver Fluxo"
                  onClick={() =>
                    history.push({
                      pathname: "/workflow/",
                      state: "active",
                      search:
                        "?" +
                        new URLSearchParams({
                          flowId: projects[item.title][0].flowId,
                        }).toString(),
                    })
                  }
                />
              </ActiveHeader>
              <Iterable
                setTask={setTask}
                tasks={projects[item.title]}
                project={item.title}
              />
            </ActiveContainer>
          ) : (
            <>
              <PassiveContainer
                onClick={() => {
                  setActive((list) => updateCheck(list, item));
                }}
              >
                <ArrowRightTask />
                {item.title}
              </PassiveContainer>
            </>
          )}
        </Fragment>
      ))}
    </>
  ) : (
    "Sem tarefas no momento..."
  );
};

export default ProjectIteraction;
